<template>
    <v-container class="white mt-5">
    
        <div>
            <p>  {{ $t('changePass.title') }} </p>
        </div>
    
        <v-row>
            <v-col cols="12" sm="4">
                <v-text-field v-model="oldPassword" :append-icon="showOld ? 'visibility' : 'visibility_off'" :rules="passdRules" v-bind:label="$t('changePass.old_passd')"  outlined :type="showOld ? 'text' : 'password'" required @click:append="showOld = !showOld"></v-text-field>
            </v-col>
        </v-row>
    
        <v-row>
            <v-col cols="12" sm="4">
                <v-text-field v-model="password" :append-icon="showNew ? 'visibility' : 'visibility_off'" :rules="passdRules" v-bind:label="$t('changePass.new_pass')" outlined :type="showNew ? 'text' : 'password'" required @click:append="showNew = !showNew"></v-text-field>
            </v-col>
        </v-row>
    
        <v-row>
            <v-col cols="12" sm="4">
                <v-text-field v-model="confirmPassword" :error-messages="vertifyPassword" :append-icon="showConfirm ? 'visibility' : 'visibility_off'" :rules="passdRules" v-bind:label="$t('changePass.repeat_new_pass')"  outlined :type="showConfirm ? 'text' : 'password'" required @click:append="showConfirm = !showConfirm"></v-text-field>
            </v-col>
        </v-row>
    
        <v-row>
            <v-col cols="12" sm="4" class="mr-auto">
                <v-btn large block color="primary" class="normal-button" @click="changePassword"> {{ $t('changePass.btn_title') }} </v-btn>
            </v-col>
        </v-row>
    
    </v-container>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
    data: () => ({
        showOld: false,
        showNew: false,
        showConfirm: false,
        valid: true,
        oldPassword: '',
        password: '',
        confirmPassword: '',
        passdRules: [
            v => !!v || i18n.t('validate.password_require'),
            v => (v && v.length > 5) || i18n.t('validate.password_invalid'),
        ],
    }),

    computed: {
        vertifyPassword() {
            return this.password === this.confirmPassword ? '' : i18n.t('validate.not_match');
        }
    },

    methods: {
        changePassword: async function() {
            const self = this;
            const requestBody = {
                oldPassword: self.oldPassword,
                password: self.password
            };

            if (!self.oldPassword|| self.oldPassword.length == 0) {
                alert(i18n.t('validate.infor_empty'));
                return;
            }

            if (!self.password || self.password.length == 0) {
                alert(i18n.t('validate.infor_empty'));
                return;
            }

            if (!self.confirmPassword || self.confirmPassword.length == 0) {
                alert(i18n.t('validate.infor_empty'));
                return;
            }

            try {
                const response =  await this.$http.post(process.env.VUE_APP_CHANGE_PASSWORD_URL, requestBody);
                if (response.data && response.data.success) {
                    this.$fire({
                        title: i18n.t('changePass.change_success'),
                        text: "",
                        type: "success"
                        }).then(() => {
                            this.$router.push('/');
                    });
                } else if (response.data && !response.data.oldPassword) {
                    this.$fire({
                        title: "Mật khẩu cũ không đúng!",
                        text: "",
                        type: "error"
                        });
                } else {
                    alert(i18n.t('validate.request_error'));
                }
            } catch(e) {
                console.log(e.stack);
                // alert(e.message);
                alert(i18n.t('validate.request_error'));
            }
        }
    }

}
</script>

<style scoped>
p {
    color: #1D243E;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    padding-top: 20px;
}
</style>